import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "h-full w-full flex flex-col text-main-5 *:px-8 *:py-2.5 [&>*:first-child]:pt-8"
};
const _hoisted_2 = {
  key: 0,
  class: "w-full flex items-center flex-wrap gap-3 shrink-0"
};
const _hoisted_3 = {
  class: "flex items-center gap-4"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "grow flex max-sm:flex-wrap items-center justify-end gap-4"
};
const _hoisted_7 = {
  key: 0,
  class: "icon-help text-2xl text-main-5 hover:text-white cursor-pointer"
};
const _hoisted_8 = {
  key: 1,
  class: "w-full"
};
const _hoisted_9 = {
  class: "h-full flex flex-col overflow-hidden overflow-y-auto scroll"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [$props.icon ? (_openBlock(), _createElementBlock("i", _mergeProps({
    key: 0,
    class: "cursor-pointer"
  }, $props.icon), null, 16)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: "text-xl font-medium",
    innerHTML: $props.title
  }, null, 8, _hoisted_4)]), $props.description ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    class: "text-xs",
    innerHTML: $props.description
  }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "header"), $props.helpButton ? (_openBlock(), _createElementBlock("i", _hoisted_7)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "subheader"), $props.title ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[0] || (_cache[0] = [_createElementVNode("div", {
    class: "h-px w-full bg-main-5/50 shrink-0"
  }, null, -1)]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_renderSlot(_ctx.$slots, "default")])]);
}